import { DEVICE_LABEL } from "../../lib/console";

const mapping = (c) => (c.kind === "axis" ? `axis ${c.index}` : c.kind === "encoder" ? `cw B${c.cw} · ccw B${c.ccw}` : `B${c.index}`);

const Live = ({ c, id, dials, toggles, pressed }) => {
  if (c.type === "dial") return <span data-testid={`console-live-${id}`} className="font-mono text-amber-200">{dials[id] ?? "–"} / 10</span>;
  if (c.type === "toggle") return <span data-testid={`console-live-${id}`} className={`font-mono ${toggles[id] ? "text-emerald-300" : "text-slate-500"}`}>{toggles[id] ? "ON" : "OFF"}</span>;
  return <span data-testid={`console-live-${id}`} className={`inline-block h-3 w-3 rounded-full transition-colors ${pressed[id] ? "bg-cyan-300 shadow-[0_0_12px_rgba(34,211,238,0.9)]" : "bg-slate-700"}`} />;
};

export const ConsoleTable = ({ map, overrides, dials, toggles, pressed, learning, onLearn, onResetOne, onToggleEnabled }) => (
  <section data-testid="console-table" className="border border-slate-800 bg-slate-950/70">
    <table className="w-full text-left text-sm">
      <thead className="font-mono text-[11px] uppercase tracking-widest text-slate-500">
        <tr className="border-b border-slate-800"><th className="px-4 py-3">Control</th><th className="px-2 py-3">Box</th><th className="px-2 py-3">Mapping</th><th className="px-2 py-3">Live</th><th className="px-2 py-3">In game</th><th className="px-4 py-3 text-right">Learn</th></tr>
      </thead>
      <tbody>
        {Object.entries(map).map(([id, c]) => {
          const active = learning?.type === "control" && learning.id === id;
          const kind = c.kind;
          const on = c.enabled !== false;
          return (
            <tr key={id} data-testid={`console-row-${id}`} data-enabled={on} className={`border-b border-slate-900 ${active ? "bg-amber-300/10" : ""} ${on ? "" : "opacity-60"}`}>
              <td className="px-4 py-2 text-slate-200">{c.name} <span className="font-mono text-[10px] uppercase text-slate-600">{c.type}</span></td>
              <td className="px-2 py-2 font-mono text-xs text-slate-400">{DEVICE_LABEL[c.device]}</td>
              <td className="px-2 py-2 font-mono text-xs text-slate-400">{mapping(c)}{overrides[id] && <span className="ml-1 text-cyan-300">*</span>}</td>
              <td className="px-2 py-2"><Live c={c} id={id} dials={dials} toggles={toggles} pressed={pressed} /></td>
              <td className="px-2 py-2">
                <label className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-slate-400">
                  <input data-testid={`console-enabled-${id}`} type="checkbox" checked={on} onChange={(e) => onToggleEnabled(id, e.target.checked)} className="h-4 w-4 accent-cyan-300" />
                  {on ? "used" : "off"}
                </label>
              </td>
              <td className="px-4 py-2 text-right whitespace-nowrap">
                {overrides[id] && <button type="button" data-testid={`console-unlearn-${id}`} onClick={() => onResetOne(id)} className="mr-2 font-mono text-[11px] uppercase text-slate-500 hover:text-slate-200">default</button>}
                <button type="button" data-testid={`console-learn-${id}`} onClick={() => onLearn(id, kind)} className={`font-mono text-[11px] uppercase ${active ? "text-amber-200 animate-pulse" : "text-cyan-300 hover:text-white"}`}>
                  {active ? (kind === "encoder" ? (learning.step === "cw" ? "turn clockwise… (click to cancel)" : "now anticlockwise… (click to cancel)") : kind === "axis" ? "turn the dial… (click to cancel)" : "press it… (click to cancel)") : "learn"}
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </section>
);
